<!-- 侧边栏跳转双美5G过渡页 -->
<template>
</template>

<script>
    import { getCookie } from "@/utils";

    export default {
        name: 'navigateTo5G',
        data() {
            return {
                empNo: "", //工号
            }
        },
        async created() {
            this.empNo = localStorage.getItem("empNo") || getCookie("empNo");
            this.jumpTo5G()
        },
        methods: {
            jumpTo5G() {
                window.location.replace(`${window.SITE_CONFIG['5GLink']}?userId=${this.empNo}&state=25`)
            },
        },
    }
</script>

<style scoped lang="less"></style>
